var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.44741 22.1286C12.6605 25.6995 18.9708 25.1788 22.5417 20.9657C26.1126 16.7526 25.5919 10.4424 21.3788 6.87145C17.1657 3.30054 10.8555 3.82117 7.28455 8.03431C3.71365 12.2474 4.23427 18.5577 8.44741 22.1286Z",
    stroke: "#636363",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6202 9.39259L10.1545 17.0211L10.0889 12.4587M13.206 19.6074L19.6717 11.9789L19.7373 16.5413",
    stroke: "#636363",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.50907515de26a688bb5779ffa2b32099.svg";
export { ForwardRef as ReactComponent };